import React from 'react';
import { styled, th } from '@elliemae/ds-system';
import { describe } from '@elliemae/ds-props-helpers';
import { type DSBackdropT, DSBackdropPropTypes } from './react-desc-prop-types.js';

// TODO change hardcoded opacity for theme variable
const BackdropTag = styled.div<{ zIndex?: number }>`
  ${({ type }) => (type === 'cover' ? 'position: fixed' : 'position: absolute')};

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${th.color('neutral-800')};
  opacity: 0.7;
  z-index: ${({ zIndex, theme }) => (zIndex ? `${zIndex}` : theme.zIndex.backdrop)};
`;

export const DSBackdrop: React.ComponentType<DSBackdropT.Props> = ({
  type = 'cover',
  zIndex,
  onClick = () => null,
}) => <BackdropTag zIndex={zIndex} type={type} onClick={onClick} data-testid="ds-backdrop" />;

DSBackdrop.displayName = 'DSBackdrop';
export const DSBackdropWithSchema = describe(DSBackdrop);
DSBackdropWithSchema.propTypes = DSBackdropPropTypes;

export default DSBackdrop;
